import api from './BaseApi';

export const createAirport = async (data) => {
    try {
        const response = await api.post('/admin/airport', data);
        return response; 
    } catch (error) {
        console.error('Create Airport error:', error);
        throw error;
    }
};

export const getAirports = async (params) => {
    try {
        const response = await api.get('/admin/airport', { params });
        return response.data;
    } catch (error) {
        console.error('Get Airports error:', error);
    }
};

export const updateAirport = async (id, payload) => {
    try {
        const response = await api.put(`/admin/airport/${id}`, payload);
        return response; 
    } catch (error) {
        console.error('Update Airport error:', error);
        throw error;
    }
};

export const getSingleAirport = async (id) => {
    try {
        const response = await api.get(`/admin/airport/${id}`);
        return response.data;
    } catch (error) {
        console.error('Get Airport error:', error);
    }
};

export const deleteAirport = async (id) => {
    try {
        const response = await api.delete(`/admin/airport/${id}`);
        return response.data;
    } catch (error) {
        console.error('Delete Airport error:', error);
    }
};

export const getConcourses = async (airportId) => {
    try {
        const response = await api.get(`/admin/airport/${airportId}/concourses`);
        return response.data;
    } catch (error) {
        console.error('Get Concourses error:', error);
    }
};

export const addConcourse = async (airportId, data) => {
    try {
        const response = await api.post(`/admin/airport/${airportId}/concourses`, data);
        return response.data;
    } catch (error) {
        console.error('Create concourse error:', error);
        return error;
    }
};

export const updateConcourse = async (data) => {
    const { id, ...payload } = data;
    try {
        const response = await api.put(`/admin/airport/concourse/${id}`, payload);
        return response.data; 
    } catch (error) {
        console.error('Update Concourse error:', error);
        throw error;
    }
};

export const deleteConcourse = async (id) => {
    try {
        const response = await api.delete(`/admin/airport/concourse/${id}`);
        return response.data;
    } catch (error) {
        console.error('Delete Concourse error:', error);
    }
};

export const getFloors = async (airportId) => {
    try {
        const response = await api.get(`/admin/airport/${airportId}/floors`);
        return response.data;
    } catch (error) {
        console.error('Get Floors error:', error);
    }
};

export const addFloor = async (airportId, data) => {
    try {
        const response = await api.post(`/admin/airport/${airportId}/floors`, data);
        return response.data;
    } catch (error) {
        console.error('Create floor error:', error);
        return error;
    }
};

export const updateFloor = async (data) => {
    const { id, ...payload } = data;
    try {
        const response = await api.put(`/admin/airport/floor/${id}`, payload);
        return response.data;
    } catch (error) {
        console.error('Update Floor error:', error);
        throw error;
    }
};

export const deleteFloor = async (id) => {
    try {
        const response = await api.delete(`/admin/airport/floor/${id}`);
        return response.data;
    } catch (error) {
        console.error('Delete Floor error:', error);
    }
};

export const updateAirportStatus = async (payload) => {
    try {
        const response = await api.patch(`/admin/airport/bulk-status`, payload);
        return response; 
    } catch (error) {
        console.error('Update Airport Status error:', error);
        throw error;
    }
};